/* istanbul ignore file */
import '@apps/core/utils/publicPath';
import '@apps/core/utils/initRefreshToken';

import React from 'react';

import { renderApplication } from '@apps/core/render';
import { createRoot } from 'react-dom/client';

// Must import base style (LumX) before react component CSS.
import './index.scss';

import { App } from './components/App';

const root = createRoot(document.getElementById('login-app'));

// https://lumapps.atlassian.net/browse/IAM-1015
// must clear the init service cache when logging in.
// allows to remove old session data
// otherwise the logged-out users stays connected until cache is refreshed.
if (typeof localStorage !== 'undefined') {
    localStorage.removeItem('serviceInitCache');
}

renderApplication({
    render: () => {
        root.render(<App />);
    },
});
